import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_TRANSACTIONS_REQUEST } from "./constants";
import { Action, TransactionState } from "./types";

function items(state: TransactionState = {}, action: Action): TransactionState {
  switch (action.type) {
    case getSuccessActionType(FETCH_TRANSACTIONS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_TRANSACTIONS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_TRANSACTIONS_REQUEST):
    case getFailureActionType(FETCH_TRANSACTIONS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const transaction = combineReducers({ items, isFetching });
